const handleImageError = (e, fallbackImage) => {
    const event = e.target;
    if (event.src !== fallbackImage) {
        event.onerror = null;
        event.src = fallbackImage;
    }
};
export default handleImageError;
